var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radiokt-container"},[_c('div',{staticClass:"radio-event-box"},[_c('RadioEventBox',{attrs:{"imgurl":"/media/images/landing/ailogosong-landing.png"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }